<template>
	<div class="detail">
		<div class="w1200">
			<div class="set">
				<div>【字体：
					<span id="big" :class="fontSizeClass=='font-size-big'?'active':''"
						@click="changeFontSize(1)">大</span>
					<span id="normal" :class="fontSizeClass=='font-size-medium'?'active':''"
						@click="changeFontSize(2)">中</span>
					<span id="small" :class="fontSizeClass=='font-size-small'?'active':''"
						@click="changeFontSize(3)">小</span>
					】
				</div>
				<ul>
					<li v-if="hasFavorite=='0'" @click="addfavorite"><img src="/images/flow.png"
							class="flow active" /><span>收藏</span></li>
					<li v-if="hasFavorite=='1'" @click="removefavorite"><img src="/images/flow.png"
							class="flow" /><span>取消收藏</span></li>
					<li v-if="hasPDF==false" @click="downloadWord"><img src="/images/fileDown.png"
							class="fileDown" /><span>下载为word格式</span></li>
					<li v-if="hasPDF==true" @click="downloadPDF"><img src="/images/fileDown.png"
							class="fileDown" /><span>下载为PDF</span></li>
					<li @click="sharelink"><img src="/images/share.png" class="share" /><span>分享标题和链接</span></li>
				</ul>
			</div>
			<h1 v-html="htmltitle"></h1>
			<h2>
				<em>来源：{{resultDetailData.source}}</em>
				<em>发布时间：{{resultDetailData.publishtime?resultDetailData.publishtime.substring(0,10):''}}</em>
				<!-- <input v-if="hasFavorite=='0'" type="button" @click="addfavorite" value="收藏" class="flow"/>
					<input v-else-if="hasFavorite=='1'" type="button" @click="removefavorite" value="取消收藏" class="flow active"> -->
			</h2>
			<div v-if="!isToutiao&&resultDetailData.summary" class="desc">
				<b>【内容提要】</b>{{resultDetailData.summary}}
			</div>
			<div v-if="!hasPower" class="text_txt clearfix" style="text-align: center;">
				<p v-if="!hasPDF" v-html="(htmlcontent?htmlcontent:'')+'......'"
					style="text-align: left;text-indent: 2em;"></p>
				<img src="/images/noauth.png" style="margin: 40px;" />
				<p>未订购内容每日免费浏览5篇文章，今日次数已达上线。浏览更多内容，请拨打服务线：800-810-2346</p>
			</div>
			<div v-else-if="!hasPDF" v-html="htmlcontent" :class="fontSizeClass">
			</div>
			<div v-else>
				<iframe :src="'/pdfjs/web/viewer.html?file='+pdfUrl"
					style="width: 100%;height: 900px;border: 0;"></iframe>
			</div>

			<guanlian v-if="hasGuanlian" v-bind:relatedata="resultRelateData" v-bind:source="articleid"></guanlian>

		</div>
	</div>
</template>

<script>
	// import mulu from '@/components/detail-mulu.vue'
	// import toutiao from '@/components/detail-toutiao.vue'
	// import tuijian from '@/components/detail-tuijian.vue'
	// import dianping from '@/components/detail-dianping.vue'
	import guanlian from '@/components/detail-guanlian.vue'
	export default {
		data() {
			return {
				hasPower: true,
				isloading: true,
				articleid: "",
				sourceid: '',
				favtype: '',
				resultDetailData: {},
				resultAttData: [],
				resultRelateData: [],
				hasFavorite: '',
				hasMulu: false,
				hasToutiao: false,
				hasDianping: false,
				hasGuanlian: false,
				hasPDF: false,
				pdfUrl: '',
				keyword: '',
				htmltitle: '',
				htmlcontent: '',
				isToutiao: false,
				isFromsearch: false,
				isFromtheme: '',
				sourcecol: 'szjj',
				fontSizeClass: 'font-size-medium',
			}
		},
		components: {
			// mulu,
			// toutiao,
			// tuijian,
			// dianping,
			guanlian,
		},
		created: function() {
			this.articleid = this.$route.params.id;
			this.keyword = this.$route.query.key ? this.$route.query.key : '';
			this.sourceid = this.$route.query.source ? this.$route.query.source : '';
			this.favtype = this.$route.query.favtype ? this.$route.query.favtype : '1';
			this.isFromsearch = this.$route.query.s ? '1' : '';
			this.isFromtheme = this.$route.query.the ? '1' : '';
			this.sourcecol = this.$route.query.col ? this.$route.query.col : 'szjj';
			this.isToutiao = this.$route.params.toutiaoflag ? true : false;
			this.getdetailfnc();
			this.getrelatefnc();
		},
		mounted: function() {
			document.body.scrollTop = 0;
			document.documentElement.scrollTop = 0;
		},
		computed: {

		},
		watch: {
			$route(to, from) {
				if (to.params.id != from.params.id) {
					this.articleid = to.params.id;
					this.keyword = this.$route.query.key ? this.$route.query.key : '';
					this.sourceid = this.$route.query.source ? this.$route.query.source : '';
					this.getdetailfnc();
					this.getrelatefnc();
				}
			}
		},
		methods: {
			getdetailfnc: function() {
				let _this = this;
				_this.resultDetailData = {};
				if (_this.sourceid) {
					_this.$track([
						['pagetype', '相关推荐'],
						['reqtype', '1'],
						['pageid', _this.sourceid],
						['relatedpageid', _this.articleid]
					]);
				}
				this.$http({
						method: 'get',
						url: 'article/getById',
						responseType: 'json',
						params: {
							id: this.articleid,
							userid: this.$cookies.get('userinfo') ? this.$cookies.get('userinfo').userAccountID :
								'',
							searchparm: this.isFromsearch,
							strtype: this.isFromtheme,
							ColAlias: this.sourcecol,
						},
					})
					.then(function(response) {
						// console.log(response);
						// debugger;
						if (response.data.code == 40003) {
							alert(response.data.msg);
							window.location.href = '/';
							return false;
						}

						_this.hasPower = response.data.data.data.isReadArt == 0 ? false : true;

						if (response.data.data.data.article) {
							if (_this.hasPower) {
								_this.$track([
									['pagetype', '文章'],
									['reqtype', '1'],
									['pageid', _this.articleid]
								]);
							}
							_this.resultDetailData = response.data.data.data.article;
							_this.resultAttData = response.data.data.data.att;
							document.title = _this.resultDetailData.articletitle + '-数字中国专版';
							_this.hasFavorite = (_this.$cookies.get('userinfo') && (_this.resultDetailData
								.userid == _this.$cookies.get('userinfo').userAccountID)) ? '1' : '0';
							_this.hasPDF = false;
							
							
							///附件替换
							////////////////////////////////////////////////////////////////////////////
							// if(_this.resultDetailData.articlehtmlcontent&&_this.resultDetailData.articlehtmlcontent.indexOf('/attachment')>-1){
							// debugger
							
							if(_this.resultAttData.length>0){
								var preurl=window.location.pathname;
								preurl=preurl.substring(0,preurl.indexOf('detail/')>-1?preurl.indexOf('detail/'):preurl.length);
								preurl=window.location.protocol+'//'+window.location.host+preurl;
								var pdfdownloadurl=(process.env.NODE_ENV === 'development' ? '/proxyapi/' : preurl)+'article/DownLoad?searchparm='+_this.isFromsearch+'&strtype='+_this.isFromtheme+'&ColAlias='+_this.sourcecol+'&articleId=';
								var attdownloadurl=(process.env.NODE_ENV === 'development' ? '/proxyapi/' : preurl)+'article/DownLoadByAttID?searchparm='+_this.isFromsearch+'&strtype='+_this.isFromtheme+'&ColAlias='+_this.sourcecol+'&articleId='+_this.articleid+'&attId=';
								for(var i=0;i<_this.resultAttData.length;i++){
									if(_this.resultAttData[i].filetype=='mp4'){
										_this.resultDetailData.articlehtmlcontent='<video style="width:100%;margin-bottom:30px;" controls controlsList="nodownload"><source src="'+_this.resultAttData[i].url+'" type="video/mp4">您的浏览器不支持播放此视频</video>'+_this.resultDetailData.articlehtmlcontent;
									}
									else{
										if(_this.resultAttData[i].showinpage){
											var attRegExp=new RegExp('&lt;attachment id=&quot;'+_this.resultAttData[i].attid+'&quot;&gt;(.*?)&lt;/attachment&gt;');
											var matchArr=_this.resultDetailData.articlehtmlcontent.match(attRegExp);
											if(matchArr.length>1&&matchArr[1]==''){
												_this.resultDetailData.articlehtmlcontent=_this.resultDetailData.articlehtmlcontent.replace(matchArr[0],'<a href="'+attdownloadurl+_this.resultAttData[i].attid+'" style="color:blue;" id="'+_this.resultAttData[i].attid+'">下载附件</a>');
											}
											else{
												_this.resultDetailData.articlehtmlcontent=_this.resultDetailData.articlehtmlcontent.replace('&lt;attachment id=&quot;'+_this.resultAttData[i].attid+'&quot;&gt;','<a href="'+attdownloadurl+_this.resultAttData[i].attid+'" style="color:blue;" id="'+_this.resultAttData[i].attid+'">');
												_this.resultDetailData.articlehtmlcontent=_this.resultDetailData.articlehtmlcontent.replace('&lt;/attachment&gt;','</a>');
											}
										}
										else{
											_this.hasPDF=true;
											_this.pdfUrl=encodeURIComponent(pdfdownloadurl+_this.articleid);
											break;
										}
									}
									
								}
							}
							// else{
							// 	_this.hasPDF=true;
							// 	_this.pdfUrl=encodeURIComponent(pdfdownloadurl+_this.articleid);
							// }
							// }
							////////////////////////////////////////////////////////
							
							if (_this.keyword) {
								var regExp = new RegExp(_this.keyword, 'g');
								_this.htmltitle = _this.resultDetailData.articletitle.replace(regExp,
									'<span style="color:#2C68FF;">' + _this.keyword + '</span>');
								_this.htmlcontent = _this.resultDetailData.articlehtmlcontent.replace(regExp,
									'<span style="color:#2C68FF;">' + _this.keyword + '</span>');
							} else {
								_this.htmltitle = _this.resultDetailData.articletitle;
								_this.htmlcontent = _this.resultDetailData.articlehtmlcontent;
							}
						} else {
							_this.$alert('此文章不存在，点击确定回到首页', '错误', {
								confirmButtonText: '确定',
								callback: action => {
									_this.$router.push('/');
								}
							});
						}
						document.body.scrollTop = 0;
						document.documentElement.scrollTop = 0;
						_this.isloading = false;
					})
					.catch(function(error) {
						_this.isloading = false;
						console.log(error);
					});
			},
			getrelatefnc: function() {
				let _this = this;
				_this.resultRelateData = [];
				this.$http({
						method: 'get',
						url: 'SearchInfo/CurArtSearchListInfo',
						responseType: 'json',
						params: {
							id: this.articleid,
						},
					})
					.then(function(response) {
						_this.resultRelateData = response.data.data.data;
						if (_this.resultRelateData.length) {
							_this.hasGuanlian = true;
						} else {
							_this.hasGuanlian = false;
						}
					})
					.catch(function(error) {
						console.log(error);
					});;
			},
			addfavorite: function() {
				if (this.$cookies.get('userinfo') && this.$cookies.get('userinfo').userAccountID) {
					let _this = this;
					this.$http({
							method: 'post',
							url: 'article/addToFavorites',
							responseType: 'json',
							params: {
								userid: this.$cookies.get('userinfo').userAccountID,
								id: this.articleid,
								articletype: this.favtype
							},
						})
						.then(function(response) {
							if (response.data.success) {
								_this.$message({
									message: '收藏成功',
									type: 'success'
								});
								_this.hasFavorite = 1;
								_this.$track([
									['pagetype', '添加收藏'],
									['pageid', _this.articleid]
								]);
							}
						})
						.catch(function(error) {
							console.log(error);
						});
				}
			},
			removefavorite: function() {
				if (this.$cookies.get('userinfo') && this.$cookies.get('userinfo').userAccountID) {
					let _this = this;
					this.$http({
							method: 'post',
							url: 'article/removeFromFavorites',
							responseType: 'json',
							params: {
								userid: this.$cookies.get('userinfo').userAccountID,
								id: this.articleid
							},
						})
						.then(function(response) {
							if (response.data.success) {
								_this.$message({
									message: '已取消收藏',
									type: 'success'
								});
								_this.hasFavorite = 0;
								_this.$track([
									['pagetype', '删除收藏'],
									['pageid', _this.articleid]
								]);
							}
						})
						.catch(function(error) {
							console.log(error);
						});
				}
			},
			changeFontSize: function(type) {
				if (type == 1) {
					this.fontSizeClass = "font-size-big";
					this.$track([
						['pagetype','文章详情-id:'+this.articleid+'-改变字号:大-点击'],
					]);
				} else if (type == 3) {
					this.fontSizeClass = "font-size-small";
					this.$track([
						['pagetype','文章详情-id:'+this.articleid+'-改变字号:小-点击'],
					]);
				} else {
					this.fontSizeClass = "font-size-medium";
					this.$track([
						['pagetype','文章详情-id:'+this.articleid+'-改变字号:中-点击'],
					]);
				}
			},
			jumppush: function(to) {
				var a = document.createElement('a');
				a.setAttribute('href', to);
				a.setAttribute('style', 'display:none');
				// a.setAttribute('target', '_blank');  
				document.body.appendChild(a);
				a.click();
				a.parentNode.removeChild(a);
			},
			downloadWord: function() {
				this.$message({
					message: '已下载',
					type: 'success'
				});
				this.$track([
					['pagetype', '下载Word'],
					['pageid', this.articleid]
				]);
				this.jumppush((process.env.NODE_ENV === 'development' ? '/proxyapi' : '') +
					'/article/DownLoadWord?id=' + this.articleid);
			},
			downloadPDF: function() {
				this.$message({
					message: '已下载',
					type: 'success'
				});
				this.$track([
					['pagetype', '下载PDF'],
					['pageid', this.articleid]
				]);
				this.jumppush((process.env.NODE_ENV === 'development' ? '/proxyapi' : '') +
					'/article/DownLoad?articleId=' + this.articleid);
			},
			sharelink: function() {
				// debugger
				var temptext = '';
				temptext += '标题：' + this.resultDetailData.articletitle + '\r\n';
				temptext += '链接：' + window.location.href + '\r\n';
				temptext += '来源：数字中国专版';
				const textarea = document.createElement('textarea'); 
				textarea.value = temptext; 
				document.body.appendChild(textarea);
				textarea.select();
				document.execCommand('Copy');
				document.body.removeChild(textarea);
				this.$track([
					['pagetype', '分享'],
					['pageid', this.articleid]
				]);
				this.$message({
					message: '复制分享链接成功',
					type: 'success'
				});
				// this.$alert('分享链接已复制', '成功', {
				// 	confirmButtonText: '确定',
				// });
				// // for ie
				// if (window.clipboardData) {
				// 	window.clipboardData.clearData();
				// 	window.clipboardData.setData('text', temptext);
				// }
				// // for modern browser
				// else if (document.execCommand) {
				// 	var element = document.createElement('textarea');
				// 	element.textContent = temptext;
				// 	document.body.appendChild(element);
				// 	if (document.selection) {
				// 		var range = document.body.createTextRange();
				// 		range.moveToElementText(element);
				// 		range.select();
				// 	} else if (window.getSelection) {
				// 		var range = document.createRange();
				// 		range.selectNode(element);
				// 		window.getSelection().removeAllRanges();
				// 		window.getSelection().addRange(range);
				// 	}
				// 	document.execCommand('copy');
				// 	element.remove ? element.remove() : element.removeNode(true);
				// }
			}
		}
	}
</script>

<style>
</style>
